// extracted by mini-css-extract-plugin
module.exports = {"dialog":"style__dialog___XDbiz","toolbar":"style__toolbar___2SLBn"};